import { useEffect, useState } from "react";

const KEY = "sj_pairings";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const pairKey = (p) => [p.board, p.stone, p.handle || "", p.finish || ""].join("|");

export const useSavedPairs = () => {
  const [pairs, setPairs] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(pairs));
  }, [pairs]);

  const save = (p) => setPairs((list) => (list.some((x) => pairKey(x) === pairKey(p)) ? list : [...list, p]));
  const remove = (k) => setPairs((list) => list.filter((x) => pairKey(x) !== k));
  const setSnapshot = (k, snapshot) => setPairs((list) => list.map((x) => (pairKey(x) === k ? { ...x, snapshot } : x)));
  return { pairs, save, remove, setSnapshot, clear: () => setPairs([]) };
};
